import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

type LoaderProps = {
    className?: string;
};

export const Loader = ({ className }: LoaderProps) => {
    return (
        <Loader2 className={cn('h-8 w-8 animate-spin text-white', className)} />
    );
};
